import { CheckOutlined, CloseOutlined, EyeOutlined } from "@ant-design/icons";
import queryString from "query-string";
import React, { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
import { apiClient } from "../../../../api";
import TermsOfService from "../../../../components/Modal/TermsOfService.js";
import {
  recaptchakey,
} from "../../../../config";
import FacebookLogo from "../../../../img/vendors/icon/facebook.png";
import GoogleLogo from "../../../../img/vendors/icon/google.png";
import LineLogo from "../../../../img/vendors/icon/line.png";
import "./RegisterForm.scss";
import PrivacyPolicy from "../../../../components/Modal/PrivacyPolicy.js";

export default function RegisterForm({
  model,
  setModel,
  errorMessage,
  setErrorMessage,
  state,
  setState,
  recaptchaRef,
  callGetOTP,
  loading,
  setLoading,
  pid,
  type
}) {
  const history = useHistory()
  const [openModal, setOpenModal] = useState("");
  const [platformEnv, setPlatformEnv] = useState(null);
  const [provider, setProvider] = useState("");

  useEffect(() => {
    apiClient.get("/api/PlatformEnv")
      .then((response) => {
        setPlatformEnv(response.data)
      })
      .catch((error) => {
        setLoading(false);
        setErrorMessage(error.message);
      });
  }, []);


  const onChangeRecapha = (token) => {
    setModel({ ...model, recaptchaToken: token });
    setErrorMessage("")
  };

  const onSubmit = async () => {
    setErrorMessage("");
    setLoading(true);

    const recaptchaValue = recaptchaRef.current.getValue();
    if (recaptchaValue == "") {
      setLoading(false);
      setErrorMessage("Please verify reCAPTCHA");
      return;
    }

    recaptchaRef.current.reset();

    let req = {
      name: model.contactName,
      email: model.email,
      username: model.email,
      password: model.password,
      repeatpassword: model.confirmPassword,
      recaptchatoken: model.recaptchaToken
        ? model.recaptchaToken
        : recaptchaValue,
      typeUser: model.typeUser,
      pid: queryString.parse(window.location.search).pid,
    };

    await apiClient
      .post("api/accountregister/validate", req, {
        headers: { "Content-type": "application/json; charset=UTF-8" },
      })
      .then((response) => {
        if (response.data.validationResult) {
          setLoading(false);
          callGetOTP();
        } else {
          setLoading(false);
          setErrorMessage(response.data.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        setErrorMessage(error.message);
      });
  };

  const checkPrivacyPolicy = (provider) => {
    if (!model.agreeTerms) {
      setOpenModal("policy")
    } else {
      if (provider) {
        loginWithProvider(provider)
      } else {
        onSubmit()
      }
    }
    setProvider(provider)
  }

  const loginWithProvider = async (channel = null) => {
    if (!platformEnv) return; // Wait for config to load
    setErrorMessage("");
    setLoading(true);

    if (!model.recaptchaToken) {
      setLoading(false);
      setErrorMessage("Please verify reCAPTCHA");
      return;
    }

    try {
      // 1. เรียก backend เพื่อ validate recaptcha ก่อน
      const res = await apiClient.post("/api/PlatformEnv/validate-recaptcha",
        { recaptcha: model.recaptchaToken },
        { headers: { "Content-type": "application/json; charset=UTF-8" } })

      if (!res.data.validationResult) {
        setErrorMessage(res.data.message || "Recaptcha validation failed.");
        setLoading(false)
        setModel({ ...model, recaptchaToken: "" });
        return;
      } else {
        // 2. ถ้า validate ผ่าน -> redirect ไปยัง provider
        const page = 'register'
        const stateObj = {
          provider: channel ? channel : provider,
          page,
          ...pid ? { pid } : {},
          ...type ? { type } : {}
        };
        const stateParam = encodeURIComponent(JSON.stringify(stateObj));
        let url = "";

        if (stateObj.provider === "facebook") {
          url = `https://www.facebook.com/v17.0/dialog/oauth?client_id=${platformEnv.facebookId}&redirect_uri=${platformEnv.redirectUrl}&scope=email,public_profile&state=${stateParam}`;
        } else if (stateObj.provider === "google") {
          url = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${platformEnv.googleId}&redirect_uri=${platformEnv.redirectUrl}&response_type=code&scope=email profile&state=${stateParam}`;
        } else if (stateObj.provider === "line") {
          url = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${platformEnv.lineId}&redirect_uri=${platformEnv.redirectUrl}&state=${stateParam}&scope=profile%20openid%20email`;
        }

        window.location.href = url;
      }


      setModel({ ...model, recaptchaToken: "" });
      setLoading(false)
    } catch (err) {
      setErrorMessage("Recaptcha validation error: " + err.message);
    }
  };

  const onLoginClick = () => {
    history.push("/login")
  }

  // Password rule definitions
  const passwordRules = [
    {
      key: 'length',
      label: 'The password must be at least 6 characters long.',
      check: (model) => model.password && model.password.length >= 6,
      show: () => true,
    },
    {
      key: 'composition',
      label: 'It consists of the following characters.',
      check: (model) => model.password &&
        /[A-Z]/.test(model.password) &&
        /[a-z]/.test(model.password) &&
        /[0-9]/.test(model.password) &&
        /[=\/\\\(\)!#$%\^&,\.\+\*@_\-\?;:]/.test(model.password),
      show: () => true,
      subRules: [
        {
          key: 'uppercase',
          label: 'Uppercase letter (A-Z)',
          check: (model) => model.password && /[A-Z]/.test(model.password),
        },
        {
          key: 'lowercase',
          label: 'Lowercase letter (a-z)',
          check: (model) => model.password && /[a-z]/.test(model.password),
        },
        {
          key: 'digit',
          label: 'Digit (0-9)',
          check: (model) => model.password && /[0-9]/.test(model.password),
        },
        {
          key: 'special',
          label: 'Special character ( = / \\ ( ) ! # $ % ^ & , . + * @ _ - ? ;: )',
          check: (model) => model.password && /[=\/\\\(\)!#$%\^&,\.\+\*@_\-\?;:]/.test(model.password),
        },
      ],
    },
    {
      key: 'match',
      label: '2 inputs match',
      check: (model) => model.password && model.confirmPassword && model.password === model.confirmPassword,
      show: () => true,
    },
  ];

  // Email validation function
  const isValidEmail = (email) => {
    // Simple email regex
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
  const emailHasError = model.email && !isValidEmail(model.email);

  // Password rules validation
  const isPasswordValid = passwordRules[0].check(model) &&
    passwordRules[1].subRules.every(subRule => subRule.check(model)) &&
    passwordRules[2].check(model);

  // Form validation
  const isFormValid =
    model.contactName &&
    isValidEmail(model.email) &&
    isPasswordValid &&
    // model.agreeTerms &&
    model.recaptchaToken;

  return (
    // <div className="register-card">
    //   <Banner page="register"/>
    <div className="register-root">
      <div className="register-title-section">
        <div className="register-title">Create a user account</div>
        <div className="register-subtitle">
          <span className="register-subtext">Already have an account?</span>
          <span className="register-link" onClick={onLoginClick}>Log in</span>
        </div>
      </div>
      <div className="register-form-section">
        <form className="register-form" onSubmit={e => { e.preventDefault(); checkPrivacyPolicy(null); }}>
          <div className="register-input-group">
            <label className="register-label">Contact Name</label>
            <input
              className="register-input"
              placeholder="Name"
              value={model.contactName}
              onChange={e => setModel({ ...model, contactName: e.target.value })}
              autoComplete="off"
            />
          </div>
          <div className="register-input-group">
            <label className="register-label">Email</label>
            <input
              className="register-input"
              placeholder="Email"
              value={model.email}
              onChange={e => setModel({ ...model, email: e.target.value })}
              autoComplete="off"
            />
            {emailHasError && (
              <div className="register-error" style={{ textAlign: 'left', marginTop: 0 }}>
                Please enter a valid email address.
              </div>
            )}
          </div>
          <div className="register-input-group register-password-group">
            <label className="register-label">Password</label>
            <div className="register-password-wrapper">
              <input
                type={state.showPassword ? "text" : "password"}
                className="register-input"
                style={{ width: "100%" }}
                value={model.password}
                onChange={e => setModel({ ...model, password: e.target.value })}
                placeholder="**********"
                autoComplete="off"
              />
              <span className="register-eye-icon-wrapper">
                <EyeOutlined
                  className="register-eye-icon"
                  onClick={() => setState({ ...state, showPassword: !state.showPassword })}
                  style={{ cursor: "pointer" }}
                />
              </span>
            </div>
          </div>
          <div className="register-input-group register-password-group">
            <label className="register-label">Confirm Password</label>
            <div className="register-password-wrapper">
              <input
                type={state.showConfirmPassword ? "text" : "password"}
                className="register-input"
                style={{ width: "100%" }}
                value={model.confirmPassword}
                onChange={e => setModel({ ...model, confirmPassword: e.target.value })}
                placeholder="**********"
                autoComplete="off"
              />
              <span className="register-eye-icon-wrapper">
                <EyeOutlined
                  className="register-eye-icon"
                  onClick={() => setState({ ...state, showConfirmPassword: !state.showConfirmPassword })}
                  style={{ cursor: "pointer" }}
                />
              </span>
            </div>
          </div>
          <div className="register-captcha">
            <ReCAPTCHA
              stoken={model.recaptchaToken}
              sitekey={recaptchakey}
              onChange={onChangeRecapha}
              ref={recaptchaRef}
            />
          </div>

          {/* Password requirements */}
          {model.password || model.confirmPassword ? (
            <div className="register-password-rules">
              {passwordRules.map(rule => (
                rule.show(model) && (
                  <React.Fragment key={rule.key}>
                    <div className="register-password-rule-row">
                      {rule.key === 'match'
                        ? (model.password === undefined || model.password === '' || model.confirmPassword === undefined || model.confirmPassword === '' ? (
                          <span className="register-password-rule-icon-circle default" />
                        ) : (rule.check(model) ? (
                          <span className="register-password-rule-icon-circle check">
                            <CheckOutlined className="register-password-rule-icon" />
                          </span>
                        ) : (
                          <span className="register-password-rule-icon-circle close">
                            <CloseOutlined className="register-password-rule-icon" />
                          </span>
                        )))
                        : (model.password === undefined || model.password === '' ? (
                          <span className="register-password-rule-icon-circle default" />
                        ) : (rule.check(model) ? (
                          <span className="register-password-rule-icon-circle check">
                            <CheckOutlined className="register-password-rule-icon" />
                          </span>
                        ) : (
                          <span className="register-password-rule-icon-circle close">
                            <CloseOutlined className="register-password-rule-icon" />
                          </span>
                        )))}
                      <p>{rule.label}</p>
                    </div>
                    {rule.subRules && (
                      <div className="register-password-rule-sublist">
                        {rule.subRules.map(subRule => (
                          <div className="register-password-rule-row" key={subRule.key}>
                            {model.password === undefined || model.password === '' ? (
                              <span className="register-password-rule-icon-circle default" />
                            ) : (subRule.check(model) ? (
                              <span className="register-password-rule-icon-circle check">
                                <CheckOutlined className="register-password-rule-icon" />
                              </span>
                            ) : (
                              <span className="register-password-rule-icon-circle close">
                                <CloseOutlined className="register-password-rule-icon" />
                              </span>
                            ))}
                            <p>{subRule.label}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </React.Fragment>
                )
              ))}
            </div>
          ) : null}

          {errorMessage && <div className="register-error">{errorMessage}</div>}
          <button
            type="submit"
            className="register-submit-btn"
            disabled={loading || !isFormValid}
          >
            {loading ? "Creating User..." : "Create User"}
          </button>
        </form>
        <div className="register-divider">
          <hr className="register-divider-line" />
          <span className="register-divider-text">Or</span>
          <hr className="register-divider-line" />
        </div>
        <div className="register-social-btns">
          <button className="register-social-btn" disabled={loading} onClick={() => checkPrivacyPolicy("google")}>
            <img src={GoogleLogo} alt="Google" className="register-social-icon" />
            <div className="register-social-btn-text">ลงชื่อเข้าใช้งานด้วย Google</div>
          </button>
          {/* Hide Facebook login button for now */}
          {/* <button className="register-social-btn" disabled={loading} onClick={() => checkPrivacyPolicy("facebook")}>
            <img src={FacebookLogo} alt="Facebook" className="register-social-icon" />
            <div className="register-social-btn-text">ลงชื่อเข้าใช้งานด้วย Facebook</div>
          </button> */}
          <button className="register-social-btn" disabled={loading} onClick={() => checkPrivacyPolicy("line")}>
            <img src={LineLogo} alt="Line" className="register-social-icon" />
            <div className="register-social-btn-text">ลงชื่อเข้าใช้งานด้วย Line</div>
          </button>
        </div>
        <div className="register-terms">
          <div className="terms-condition">
            <input
              type="checkbox"
              checked={model.agreeTerms ? model.agreeTerms : false}
              onChange={e => {
                setModel({ ...model, agreeTerms: e.target.checked })
                setErrorMessage("")
              }}
            />
            <span>
              By continuing, you agree to Platform’s <span className="register-terms-link" onClick={() => setOpenModal("terms")}>Terms of Service</span> &nbsp;
              and acknowledge you’ve read our <span className="register-terms-link" onClick={() => setOpenModal("policy")}>Privacy Policy</span>
            </span>
          </div>
        </div>
      </div>
      <TermsOfService open={openModal === "terms"} setOpen={setOpenModal} />
      <PrivacyPolicy open={openModal === "policy"} setOpen={setOpenModal} setIsAgree={() => setModel({ ...model, agreeTerms: true })} />
    </div>
    // </div>

  );
} 